export default __webpack_public_path__ + "static/media/SWT0520.34I-20380_-14784_0.84d9aa42.jpg";